import React, { createContext, useContext, useMemo, useState } from 'react';

// TEMPORARY compatibility file — currency stub for compile/runtime safety.

const CurrencyContext = createContext(null);

const DEFAULT_CURRENCIES = [
  { code: 'USD', iso: 'USD', symbol: '$', name: 'US Dollar', rate: 1 },
  { code: 'EUR', iso: 'EUR', symbol: '€', name: 'Euro', rate: 0.92 },
  { code: 'AED', iso: 'AED', symbol: 'د.إ', name: 'UAE Dirham', rate: 3.67 },
];

export function CurrencyProvider({ children }) {
  const [selectedCurrency, setSelectedCurrency] = useState(DEFAULT_CURRENCIES[0]);
  const [availableCurrencies] = useState(DEFAULT_CURRENCIES);
  const [isLoadingCurrencies] = useState(false);

  const convertToSelectedCurrency = (amountUsd) => {
    const n = Number(amountUsd) || 0;
    const rate = Number(selectedCurrency?.rate) || 1;
    return n * rate;
  };

  const value = useMemo(
    () => ({
      selectedCurrency,
      setSelectedCurrency,
      availableCurrencies,
      isLoadingCurrencies,
      convertToSelectedCurrency,
    }),
    [selectedCurrency, availableCurrencies, isLoadingCurrencies]
  );

  return (
    <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) {
    return {
      selectedCurrency: DEFAULT_CURRENCIES[0],
      setSelectedCurrency: () => {},
      availableCurrencies: DEFAULT_CURRENCIES,
      isLoadingCurrencies: false,
      convertToSelectedCurrency: (n) => Number(n) || 0,
    };
  }
  return ctx;
}

export default CurrencyContext;
